// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"141f5267","260":"7573f26c","670":"d29ef985","705":"b1c137b2","824":"2c5b0730"}[chunkId] + ".chunk.css";
};